module.exports = __webpack_public_path__ + "media/img/about/bg-vision-4c2a2f15a9fcc34e74502835401719bc.png";